/* eslint-disable max-len */
/* eslint-disable camelcase */
import { API } from '@/redux/config';
import { toast } from 'react-toastify';
import {
	restoreFileFromRecycleBin,
	restoreFolder,
	getItemsFromRecyclingBin,
} from '@/redux/actions/sharepointActions';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
	start,
	setReducerError,
	startBySiteId,
	setGraphImageError,
	graphImageStart,
	setGraphUploadFileError,
	setAllSites,
	setCreateNewFolder,
	setCurrentDirectory,
	setCurrentDirectoryBySiteId,
	setCurrentPath,
	setCustomerDirectory,
	setDeletedWebhookIntegrationsByID,
	setDiagramsDirectory,
	setDownloadFile,
	setDuplicateFile,
	setDuplicateFolder,
	setEditDiagramToggle,
	setFileProperties,
	setFolderProperties,
	setFolderPropertiesToggle,
	setFolders,
	setGraphApiToken,
	setImage,
	setImagePreview,
	setMetaDataStatus,
	setMetadataSync,
	setMoveFile,
	setMoveFileErrorToggle,
	setMoveToRecycleBin,
	setMovedFolder,
	setNewFolderToggle,
	setRecyclingBinToggle,
	setRegisterIntegrations,
	setRenameFile,
	setRenameFileToggle,
	setRenameFolderToggle,
	setRenewedWebhookIntegrationsByID,
	setSharePointDriveBySite,
	setSharepointNotification,
	setSiteList,
	setSiteListByName,
	setSitesByName,
	setSubscriptionOfList,
	setToggleIntegrationsInformationModal,
	setToggleModal,
	setUploadFile,
	setUploadFileToggle,
	setWebhookIntegrationsByID,
	setWebhookIntegrationsExpiration,
	setToggleRestoreItem,
	setFilePropertiesToggle,
	setPrimaryWebhookIntegrations,
	setArchiveToggle,
} from '../reducers/graphapiReducer';
import { StnAPI } from '../config/customHeadersApi';
import { useCustomerId } from '../../utils/hooks/useCustomerId';

// Get Graph API Token
export const getGraphAPIToken = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/access_token');

		dispatch(setGraphApiToken(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get all Sites
export const getAllSites = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/sites');

		dispatch(setAllSites(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Portal Sites
export const getPortalSites = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/site/portal');

		dispatch(setSitesByName(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Lists in a Site
export const getListsInSite = site_id => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`/graphapi/sharepoint/site/lists?site_id=${site_id}`,
		);

		dispatch(setSiteList(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Lists by Name in a Site
export const getListsByNameInSite = (site_id, list_name) => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`/graphapi/sharepoint/list/name?site_id=${site_id}&list_name=${list_name}`,
		);

		dispatch(setSiteListByName(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Sharepoint Drive by Site ID
export const getSharepointDriveBySiteID = site_id => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`/graphapi/sharepoint/site/drive?site_id=${site_id}`,
		);

		dispatch(setSharePointDriveBySite(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Integrations of a List
export const getIntegrationsOfList = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/subscriptions');

		dispatch(setSubscriptionOfList(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

export const registerWebhookIntegrations =
	(site_id, list_id, toggle, is_primary) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.post(
				`/graphapi/sharepoint/subscriptions?site_id=${site_id}&list_id=${list_id}&days=29&is_primary=${is_primary}`,
			);

			dispatch(setRegisterIntegrations(response?.data));
			toast.success('Integrations Registered Successfully');
			dispatch(getIntegrationsOfList());
			toggle();
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'post');
		}
	};

// Get Status of Local Metadata
export const getStatusOfLocalMetadata = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/metadata');

		dispatch(setMetaDataStatus(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Webhook Subcription by ID
export const getWebhookIntegrationsByID = subscription_id => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`/graphapi/sharepoint/subscriptions/${subscription_id}`,
		);

		dispatch(setWebhookIntegrationsByID(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Delete Webhook Subcription by ID
export const deleteWebhookIntegrationsByID =
	subscription_id => async dispatch => {
		try {
			dispatch(start());
			const response = await API.delete(
				`/graphapi/sharepoint/subscriptions/${subscription_id}`,
			);

			dispatch(setDeletedWebhookIntegrationsByID(response?.data));
			toast.success('Integrations Deleted Successfully');
			dispatch(getIntegrationsOfList());
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'delete');
		}
	};

// Get Primary Webhook Integrations
export const getPrimaryWebhookIntegrations = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/graphapi/sharepoint/subscription/primary');

		dispatch(setPrimaryWebhookIntegrations(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Renew Webhook Subcription by ID
export const renewWebhookIntegrationsByID =
	(subscription_id, primary_subscription_id) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.patch(
				`/graphapi/sharepoint/subscriptions/${subscription_id}?days=30`,
			);

			dispatch(setRenewedWebhookIntegrationsByID(response?.data));
			dispatch(getIntegrationsOfList());

			if (primary_subscription_id === subscription_id) {
				dispatch(getPrimaryWebhookIntegrations());
			}
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'patch');
		}
	};

// Get Expiration of webhook subscription
export const getExpirationOfWebhookIntegrations =
	subscription_id => async dispatch => {
		try {
			dispatch(start());
			const response = await API.get(
				`/graphapi/sharepoint/subscriptions/${subscription_id}/expiration`,
			);

			dispatch(setWebhookIntegrationsExpiration(response?.data));
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Public endpoint for sharepoint notifications
export const sharepointNotification = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.post('/graphapi/sharepoint/webhook');

		dispatch(setSharepointNotification(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'post');
	}
};

// Sync Sharepoint Metadata
export const syncSharepointMetadata =
	(site_id, drive_id, boolean) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.get(
				`/graphapi/sharepoint/sync?site_id=${site_id}&drive_id=${drive_id}&hard_sync=${boolean}`,
			);

			dispatch(setMetadataSync(response?.data));
			dispatch(getStatusOfLocalMetadata());
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

export const syncSharepointItemMetadata =
	(site_id, drive_id, path) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.get(
				`/graphapi/sharepoint/sync_item?site_id=${site_id}&drive_id=${drive_id}&path=${path}`,
			);

			dispatch(setMetadataSync(response?.data));
			dispatch(getStatusOfLocalMetadata());
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Toggle the Modal that adds an integration
export const toggleIntegrationsModal = () => async dispatch =>
	dispatch(setToggleModal());

export const subscriptionInformationModalToggle = () => async dispatch =>
	dispatch(setToggleIntegrationsInformationModal());

// Get Folder Structure of Customer
export const getGraphFoldersByCustomer = customerID => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(`graphapi/sharepoint/get_all_folders`);

		return dispatch(setFolders(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Properties of Folder and Enclosed Items
export const getGraphCurrentFolderItems = folderPath => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`graphapi/sharepoint/current_folder_items?&folderPath=${encodeURIComponent(folderPath)}`,
		);

		return dispatch(setCurrentDirectory(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

export const getCustomerDocuments = (folderPath, site_id) => async dispatch => {
	try {
		dispatch(start());
		const API_URL = site_id ? StnAPI : API;
		const response = await API_URL.get(
			`/graphapi/sharepoint/documents/customer?folderPath=${folderPath ? encodeURIComponent(folderPath) : ''}`,
			{
				headers: {
					'x-site-id': site_id || '',
				},
			},
		);
		return dispatch(setCurrentDirectory(response?.data));
	} catch (err) {
		dispatch(setCurrentDirectory({}));
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};
export const getCustomerDocumentsBySiteId =
	(folderPath, site_id, customer_id) => async dispatch => {
		try {
			dispatch(startBySiteId());
			const API_URL = site_id ? StnAPI : API;
			const response = await API_URL.get(
				`/graphapi/sharepoint/documents/customer?folderPath=${folderPath ? encodeURIComponent(folderPath) : ''}`,
				{
					headers: {
						'x-customer-id': customer_id || '',
						'x-site-id': site_id || '',
					},
				},
			);
			dispatch(setCurrentDirectoryBySiteId(response?.data));
		} catch (err) {
			dispatch(setCurrentDirectoryBySiteId({}));
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Get Properties of Customer Specified Folder and Enclosed Items
export const getGraphCurrentFolderItemsByCustomer =
	(customerID, folderPath) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.get(
				`graphapi/sharepoint/current_folder_items/customer?folderPath=${folderPath ? encodeURIComponent(folderPath) : ''}`,
			);

			return dispatch(setCustomerDirectory(response?.data));
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Get File Properties
export const getGraphFileProperties = filePath => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`graphapi/sharepoint/file_properties/?filePath=${encodeURIComponent(filePath)}`,
		);

		return dispatch(setFileProperties(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Set Current Target When User Right Clicks
export const setCurrentTarget = currentTarget => async dispatch => {
	dispatch(start());

	return dispatch(setCurrentTarget(currentTarget));
};

export const getImagePreviewForSingleDiagram =
	(imageID, site_id) => async dispatch => {
		try {
			dispatch(graphImageStart());
			const response = await API.get(
				`/graphapi/sharepoint/image_preview?image_id=${imageID}&site_id=${site_id}`,
				{
					responseType: 'blob',
				},
			);

			dispatch(setImage({ imagePreview: response?.data }));
		} catch (err) {
			// dispatch(setGraphImageError(err.response?.data));
			raiseErrorException(err, dispatch, setGraphImageError, 'get');
		}
	};
export const getImagePreviewForPdf = (imageID, site_id) => async dispatch => {
	try {
		const response = await API.get(
			`/graphapi/sharepoint/image_preview?image_id=${imageID}&site_id=${site_id}`,
			{
				responseType: 'blob',
			},
		);

		return response?.data;
	} catch (err) {
		// dispatch(setGraphImageError(err.response?.data));
		raiseErrorException(err, dispatch, setGraphImageError, 'get');
	}
};

export const getImagePreview =
	(
		link,
		UniqueId,
		ServerRelativeURL,
		FileType,
		ThumbnailHeight,
		ThumbnailWidth,
		Name,
	) =>
	async dispatch => {
		try {
			dispatch(start());

			dispatch(
				setImagePreview({
					imagePreview: link,
					UniqueId,
					ServerRelativeURL,
					FileType,
					ThumbnailHeight,
					ThumbnailWidth,
					Name,
				}),
			);
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Setting the Current Path When a Folder is Selected
export const setGraphCurrentPath = path => async dispatch =>
	dispatch(setCurrentPath(path));

// Get Properties of Customers Diagrams
export const getGraphDiagrams =
	(customerID, folderID, site_id) => async dispatch => {
		try {
			dispatch(start());
			const API_URL = site_id ? StnAPI : API;
			const response = await API_URL.get(
				`/graphapi/sharepoint/get_customer_diagrams`,
				{
					headers: {
						'x-customer-id': customerID,
						'x-site-id': site_id || '',
					},
				},
			);

			return dispatch(setDiagramsDirectory(response?.data));
		} catch (err) {
			// const errMsg = err.response?.data?.detail[0]?.msg || err.response?.data?.detail;
			// toast.error(errMsg);
			dispatch(setDiagramsDirectory([]));
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// Rename File From Graphapi
export const graphapiRenameFile =
	(
		file_id,
		new_file_name,
		drive_id,
		site_id,
		toggle,
		folder_path,
		prevRowClickedData,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			const response = await API.put(
				`/graphapi/sharepoint/rename_file?file_id=${file_id}&new_file_name=${new_file_name}&site_id=${site_id}&drive_id=${drive_id}`,
			);

			dispatch(setRenameFile(response?.data));
			toggle();
			// if (prevRowClickedData) {
			dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			// }
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error renaming file: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error renaming file: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Duplicate a File From Graphapi
export const graphapiDuplicateFile =
	(
		file_id,
		folderPath,
		drive_id,
		site_id,
		prevRowClickedData,
		rowClickedData,
		customer_ID,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			let API_URL = prevRowClickedData?.SiteId ? StnAPI : API;
			const response = await API_URL.post(
				`/graphapi/sharepoint/duplicate_file?file_id=${file_id}&site_id=${site_id}&drive_id=${drive_id}`,
				null,
				{
					headers: {
						'x-customer-id': customer_ID,
						'x-site-id': rowClickedData?.SiteId || '',
					},
				},
			);

			dispatch(setDuplicateFile(response?.data));
			// if (prevRowClickedData) {
			dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			// }
			// dispatch(getGraphCurrentFolderItems(folderPath))
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error duplicating file: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error duplicating file: ${err.response?.data?.detail}`);
			}

			// dispatch(setReducerError(err.response?.data));
			raiseErrorException(err, dispatch, setReducerError, 'post');
		}
	};

// Move File to Specified Folder From Graphapi
export const graphapiMoveFile =
	(
		file_id,
		new_folder_id,
		replace,
		drive_id,
		site_id,
		setMoveError,
		folderPath,
		ServerRelativeUrl,
		toggle,
		prevRowClickedData,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			const API_URL = prevRowClickedData?.SiteId ? StnAPI : API;
			const response = await API_URL.patch(
				`/graphapi/sharepoint/move_file?file_id=${file_id}&new_folder_id=${new_folder_id}&site_id=${site_id}&drive_id=${drive_id}&replace=${replace}`,
				null,
				{
					headers: {
						'x-site-id': prevRowClickedData?.SiteId || '',
					},
				},
			);

			dispatch(setMoveFile(response?.data));
			if (setMoveError) {
				setMoveError(null);
			}
			if (ServerRelativeUrl) {
				dispatch(getCustomerDocuments(ServerRelativeUrl));
			}
			if (toggle) {
				toggle();
			}
		} catch (err) {
			if (setMoveError) {
				setMoveError({ file_id, new_folder_id, folderPath });
			}

			raiseErrorException(err, dispatch, setReducerError, 'patch');
		}
	};

// Move to recycle bin from Graphapi
export const graphapiMoveFileToRecycleBin =
	(
		file_id,
		drive_id,
		folderPath,
		prevRowClickedData,
		rowClickedData,
		customer_ID,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			console.log('rowClickedData', rowClickedData);
			console.log('prevRowClickedData', prevRowClickedData);
			let API_URL = rowClickedData?.SiteId ? StnAPI : API;
			const response = await API_URL.delete(
				`/graphapi/sharepoint/archive_file?file_id=${file_id}&drive_id=${drive_id}`,
				{
					headers: {
						'x-customer-id': customer_ID,
						'x-site-id': rowClickedData?.SiteId,
					},
				},
			);

			dispatch(setMoveToRecycleBin(response?.data));
			// if (prevRowClickedData) {
			dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			// }
			// dispatch(getGraphCurrentFolderItems(folderPath))
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error recycling file: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error recycling file: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'delete');
		}
	};

// Restore File/Folder from Recycle Bin using SharepointAPI and sync using Graphapi
export const graphapiRestoreItemFromRecycleBin =
	(
		isFolder,
		customerID,
		recycleBinId,
		site_id,
		drive_id,
		itemPath,
		folderPath,
	) =>
	async dispatch => {
		let restore = () => restoreFileFromRecycleBin(recycleBinId);
		if (isFolder) {
			restore = () => restoreFolder(recycleBinId);
		}
		dispatch(restore())
			.then(() => dispatch(getItemsFromRecyclingBin(customerID)))
			.then(() =>
				dispatch(syncSharepointItemMetadata(site_id, drive_id, folderPath)),
			)
			.then(() => {
				dispatch(getGraphFoldersByCustomer(customerID));
				dispatch(getGraphCurrentFolderItems(isFolder ? itemPath : folderPath));
			});
	};

// Permanently delete file from Graphapi
export const graphapiPermanentlyDeleteFile =
	(file_id, drive_id, toggle, folderPath) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.delete(
				`/graphapi/sharepoint/delete_file?file_id=${file_id}&drive_id=${drive_id}`,
			);

			toggle();
			dispatch(getGraphCurrentFolderItems(folderPath));
			return response;
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error deleting file: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error deleting file: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'delete');
		}
	};

// Get Folder Properties from Graphapi
export const graphapiGetFolderProperties = folder_id => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(
			`/graphapi/sharepoint/folder_properties?folder_id=${folder_id}`,
		);

		dispatch(setFolderProperties(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Rename Folder from Graphapi
export const graphapiRenameFolder =
	(
		folder_id,
		new_folder_name,
		drive_id,
		site_id,
		toggle,
		customerID,
		prevRowClickedData,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			toggle();
			const API_URL = prevRowClickedData?.SiteId ? StnAPI : API;
			const response = await API_URL.put(
				`/graphapi/sharepoint/rename_folder?folder_id=${folder_id}&new_folder_name=${new_folder_name}&site_id=${site_id}&drive_id=${drive_id}&rename_customer_folder=false`,
				null,
				{
					headers: {
						'x-customer-id': prevRowClickedData?.customerID || customerID,
						'x-site-id': prevRowClickedData?.SiteId || '',
					},
				},
			);

			dispatch(setRenameFile(response?.data));
			toast.success('Folder renamed successfully');
			if (prevRowClickedData) {
				dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			}
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error renaming folder: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error renaming folder: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Download File from Graphapi
export const graphapiDownloadFile =
	(file_id, site_id, drive_id) => async dispatch => {
		try {
			const response = await API.get(
				`/graphapi/sharepoint/download_file?file_id=${file_id}&site_id=${site_id}&isBackground=false`,
				{
					responseType: 'blob',
				},
			);
			const header = response.headers['content-disposition'];
			let filename = header.substring(
				header.indexOf('"') + 1,
				header.lastIndexOf('"'),
			);
			if (!filename) {
				filename = decodeURI(header.substring(header.lastIndexOf("'") + 1));
			}
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();

			dispatch(setDownloadFile(response?.data));
			const boolean = false;
		} catch (err) {
			console.log('sdfgdhgh', err);
			if (err.response?.data?.detail?.includes("{'error'")) {
				toast.error(
					`Error downloading file: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error downloading file: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Duplicate folder and its contents from Graphapi
export const graphapiDuplicateFolder =
	(
		folder_id,
		drive_id,
		site_id,
		customerID,
		prevRowClickedData,
		setRowFolderDuplication,
		rowClickedData,
	) =>
	async dispatch => {
		try {
			let API_URL = prevRowClickedData?.SiteId ? StnAPI : API;
			toast.info('Folder Duplication in Progress');

			const response = await API_URL.post(
				`/graphapi/sharepoint/duplicate_folder?folder_id=${folder_id}&site_id=${site_id}&drive_id=${drive_id}`,
				null,
				{
					headers: {
						'x-customer-id': prevRowClickedData?.customerID || customerID,
						'x-site-id': rowClickedData?.SiteId || '',
					},
				},
			);

			dispatch(setDuplicateFolder(response?.data));
			// if (prevRowClickedData) {
			dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			// }
			setRowFolderDuplication(null);
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error duplicating folder: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error duplicating folder: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Add a New Folder from Graphapi
export const graphapiCreateNewFolder =
	(
		parent_folder_id,
		folder_name,
		drive_id,
		site_id,
		toggle,
		customerID,
		siteID,
		prevRowClickedData,
	) =>
	async dispatch => {
		try {
			let API_URL = prevRowClickedData?.SiteId ? StnAPI : API;

			const response = await API_URL.post(
				`/graphapi/sharepoint/new_folder?parent_folder_id=${parent_folder_id}&folder_name=${folder_name}&site_id=${site_id}&drive_id=${drive_id}`,
				null,
				{
					headers: {
						'x-customer-id': prevRowClickedData?.customerID || customerID,
						'x-site-id': prevRowClickedData?.SiteId || '',
					},
				},
			);
			toast.info('Folder Creation in Progress');
			dispatch(setCreateNewFolder(response?.data));
			if (prevRowClickedData) {
				dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			}
			if (prevRowClickedData?.SiteId) {
				if (toggle) {
					toggle();
				}
			}
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error creating folder: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error creating folder: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Move Folder to Recycling Bin from Graphapi
export const graphapiMoveFolderToRecyclingBin =
	(folder_id, drive_id, customerID, prevRowClickedData, rowClickedData) =>
	async dispatch => {
		try {
			dispatch(start());
			let API_URL = rowClickedData?.SiteId ? StnAPI : API;
			const response = await API_URL.delete(
				`/graphapi/sharepoint/archive_folder?folder_id=${folder_id}&drive_id=${drive_id}`,
				{
					headers: {
						'x-customer-id': rowClickedData?.customerID || customerID,
						'x-site-id': rowClickedData?.SiteId,
					},
				},
			);

			dispatch(setMovedFolder(response?.data));
			if (prevRowClickedData) {
				dispatch(getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl));
			}
		} catch (err) {
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error recycling folder: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error recycling folder: ${err.response?.data?.detail}`);
			}

			dispatch(setReducerError(err.response?.data));
			// raiseErrorException(err, dispatch, setReducerError, 'put');
		}
	};

// Move Folder to Specific Folder from Graphapi
export const graphapiMoveFolderToSpecificFolder =
	(
		folder_id,
		destination_folder_id,
		drive_id,
		site_id,
		customerID,
		ServerRelativeUrl,
		toggle,
		prevRowClickedData,
	) =>
	async dispatch => {
		try {
			dispatch(start());
			const API_URL = prevRowClickedData?.SiteId ? StnAPI : API;
			if (toggle) {
				toggle();
			}
			const response = await API_URL.patch(
				`/graphapi/sharepoint/move_folder?folder_id=${folder_id}&destination_folder_id=${destination_folder_id}&site_id=${site_id}&drive_id=${drive_id}`,
				null,
				{
					headers: {
						'x-site-id': prevRowClickedData?.SiteId || '',
					},
				},
			);
			if (ServerRelativeUrl) {
				dispatch(getCustomerDocuments(ServerRelativeUrl));
			}

			return response;
		} catch (err) {
			dispatch(setReducerError(err.response?.data?.detail));
			if (err.response?.data?.detail.includes("{'error'")) {
				toast.error(
					`Error moving folder: ${JSON.parse(err.response?.data?.detail.replace(/'/gi, '"')).error?.message}`,
				);
			} else {
				toast.error(`Error moving folder: ${err.response?.data?.detail}`);
			}
		}
	};

// Upload a File From Graphapi
export const graphapiUploadFile =
	(
		files,
		folder_id,
		replace,
		diagram,
		drive_id,
		site_id,
		setError,
		toggle,
		folder_path,
		file_id,
		rename,
		setLoadingBar,
		siteID,
		prevRowClickedData,
	) =>
	async dispatch => {
		const isVideoFile = file => /\.(gif|mp4|avi|mov|wmv)$/i.test(file.name);
		let API_URL = siteID || prevRowClickedData?.SiteId ? StnAPI : API;
		if (prevRowClickedData?.SiteId) {
			toast.info(`Uploading ${files.length > 1 ? 'Files' : 'File'}`);
			dispatch(toggleUploadNewFile(false));
		}

		if (Array.isArray(files)) {
			try {
				if (setLoadingBar) {
					setLoadingBar(true);
				}

				for (const file of files) {
					if (isVideoFile(file)) {
						toast.info(
							`This file type is not permitted to go through: ${file.name}`,
						);
						continue;
					}

					const data = new FormData();
					data.append('file', file);

					const result = await API_URL.put(
						`graphapi/sharepoint/upload_file?folder_id=${folder_id}&site_id=${site_id}&drive_id=${drive_id}&replace=${replace}&diagram=${diagram}&rename=${rename ?? false}`,
						data,
						{
							headers: {
								'x-customer-id': useCustomerId(),
								'x-site-id': siteID || prevRowClickedData?.SiteId,
							},
						},
					);

					dispatch(setUploadFile(result?.data));

					if (diagram && replace === true && file_id) {
						dispatch(getImagePreviewForSingleDiagram(file_id, site_id));
						dispatch(getGraphCurrentFolderItems(folder_path));
					}

					if (prevRowClickedData) {
						dispatch(
							getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl),
						);
					} else {
						dispatch(getCustomerDocuments('', siteID));
					}

					toast.success(`${file.name} Uploaded Successfully`);
				}

				if (setLoadingBar) {
					setLoadingBar(false);
				}
				if (toggle) {
					toggle();
				}
				if (setError) {
					setError(null);
				}
			} catch (err) {
				let details = {};
				console.error(err?.response?.status);

				if (err?.response?.status === 409) {
					if (err?.response?.data?.detail) {
						console.log(
							'err?.response?.data?.detail',
							err?.response?.data?.detail,
						);
						details = JSON.parse(
							err?.response?.data?.detail?.replace(/'/gi, '"'),
						);
						toast.error('Duplicate File name, Please use a different name');
					}
				} else {
					details = err.response?.data?.detail;
				}

				if (details?.error?.message) {
					if (setError) {
						setError(details?.error?.message);
					}
				} else {
					toast.error(err?.response?.data?.detail);
				}

				if (setLoadingBar) {
					setLoadingBar(false);
				}
				dispatch(setGraphUploadFileError(err.response?.data?.detail));
				dispatch(getGraphCurrentFolderItems(folder_path));
				// raiseErrorException(err, dispatch, setGraphUploadFileError, 'put');
			}
		} else {
			try {
				if (isVideoFile(files)) {
					toast.info(
						`This file type is not permitted to go through: ${files.name}`,
					);
				} else {
					const data = new FormData();
					data.append('file', files);

					const result = await API_URL.put(
						`graphapi/sharepoint/upload_file?folder_id=${folder_id}&site_id=${site_id}&drive_id=${drive_id}&replace=${replace}&diagram=${diagram}&rename=${rename ?? false}`,
						data,
						{
							headers: {
								'x-customer-id': useCustomerId(),
								'x-site-id': siteID || prevRowClickedData?.SiteId,
							},
						},
					);

					dispatch(setUploadFile(result?.data));

					if (diagram && replace === true && file_id) {
						dispatch(getImagePreviewForSingleDiagram(file_id, site_id));
						dispatch(getGraphCurrentFolderItems(folder_path));
					}

					if (prevRowClickedData) {
						dispatch(
							getCustomerDocuments(
								prevRowClickedData?.ServerRelativeUrl,
								siteID,
							),
						);
					} else {
						dispatch(getCustomerDocuments('', siteID));
					}

					toast.success(`${files.name} Uploaded Successfully`);
				}

				if (setLoadingBar) {
					setLoadingBar(false);
				}
				if (toggle) {
					toggle();
				}
				if (setError) {
					setError(null);
				}
			} catch (err) {
				let details = {};
				console.error(err?.response?.status);

				if (err?.response?.status === 409) {
					if (err?.response?.data?.detail) {
						console.log(
							'err?.response?.data?.detail',
							err?.response?.data?.detail,
						);
						details = JSON.parse(
							err?.response?.data?.detail?.replace(/'/gi, '"'),
						);
						console.log('details', details);
						toast.error(details);
					}
				} else {
					details = err.response?.data?.detail;
				}

				if (details?.error?.message) {
					if (setError) {
						setError(details?.error?.message);
					}
					toast.error(details?.error?.message);
				} else {
					toast.error(err?.response?.data?.detail);
				}
				if (setLoadingBar) {
					setLoadingBar(false);
				}
				if (prevRowClickedData) {
					dispatch(
						getCustomerDocuments(prevRowClickedData?.ServerRelativeUrl, siteID),
					);
				} else {
					dispatch(getCustomerDocuments('', siteID));
				}
				toggle();
				if (setError) {
					setError(null);
				}
				toast.success('File Uploaded Successfully');
				dispatch(getGraphCurrentFolderItems(folder_path));
				setLoadingBar(false);
				// raiseErrorException(err, dispatch, setGraphUploadFileError, 'put');
			}
		}
	};

export const toggleFolderProperties = state => async dispatch =>
	dispatch(setFolderPropertiesToggle(state));

export const toggleFileProperties = state => async dispatch =>
	dispatch(setFilePropertiesToggle(state));
export const toggleArchiveFile = state => async dispatch =>
	dispatch(setArchiveToggle(state));

export const RestoreToggle = state => dispatch => {
	dispatch(setToggleRestoreItem(state));
};

export const toggleRenameFile = state => dispatch =>
	dispatch(setRenameFileToggle(state));

export const toggleRenameFolder = state => dispatch =>
	dispatch(setRenameFolderToggle(state));

export const toggleCreateNewFolder = state => async dispatch =>
	dispatch(setNewFolderToggle(state));

export const toggleUploadNewFile = state => async dispatch =>
	dispatch(setUploadFileToggle(state));

export const toggleRecyclingBinModal = state => dispatch =>
	dispatch(setRecyclingBinToggle(state));

export const toggleEditDiagramModal = state => async dispatch =>
	dispatch(setEditDiagramToggle(state));

export const toggleMoveFileErrorModal = state => async dispatch =>
	dispatch(setMoveFileErrorToggle(state));

export const toggleUploadFileModal = state => async dispatch =>
	dispatch(setUploadFileToggle(state));
